export default "__VITE_ASSET__CyWOwW0x__"